
export default {
	name: 'LeaveTakenReportRateValueReport',
	handler: {
		// TODO: Confirm if this is necessary
		init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		},
		update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
			let params = valueAccessor();

			let taken_rates = params.taken_rates;
			let final_string = '-';

			if (taken_rates.length > 0)
			{
				final_string = '';
			}

			for (let i = 0; i < taken_rates.length; i++)
			{
				if (taken_rates[i].name !== 'no_rate')
				{
					final_string += '[' + taken_rates[i].value + ' ' + taken_rates[i].name + ']';
				}

				if (taken_rates[i].name === 'no_rate')
				{
					final_string += taken_rates[i].value;
				}

				if (i + 1 < taken_rates.length)
				{
					final_string += ' + ';
				}
			}

			element.innerHTML = final_string;
		}
	}
};
